import React, { createContext, PropsWithChildren } from 'react';

type ZoomLevelProviderProps = PropsWithChildren<{
  zoomLevel: number;
}>;

const ZoomLevelContext = createContext<number>(1);

export default function ZoomLevelProvider({ children, zoomLevel }: ZoomLevelProviderProps) {
  return <ZoomLevelContext.Provider value={zoomLevel}>{children}</ZoomLevelContext.Provider>;
}

export function useZoomLevel() {
  const context = React.useContext(ZoomLevelContext);
  if (context === undefined) {
    throw new Error(`useZoomLevel must be used within a ZoomLevelProvider`);
  }

  return context;
}
